<template>
  <p class="ajax-loader">
    <img src="../../assets/ajax-loader.gif" /> {{ message || 'Ladataan sisältöä...' }}
  </p>
</template>


<script>
  export default {
    props:['message']
  }
</script>


<style scoped>
  .ajax-loader {

  }
</style>



// WEBPACK FOOTER //
// src/components/common/AjaxLoader.vue